import { render, staticRenderFns } from "./HighlightsComponent.vue?vue&type=template&id=3a1ff118&"
import script from "./HighlightsComponent.vue?vue&type=script&lang=js&"
export * from "./HighlightsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports